export default class SmoothScrollOnLoad {

  ready() {

    /*
    * Smooth Scroll on Pageload
    * Smooth scrolling on page load if URL have a hash
    * Author: Franco Moya - @iamravenous
    */

    if (window.location.hash) {
      var hash = window.location.hash;

      if (jQuery(hash).length) {
        jQuery('html, body').animate({
          scrollTop: jQuery(hash).offset().top - 105
        }, 900, 'swing');
      }
    }

  }
}